import Swal from "sweetalert2";
import jsPDF from "jspdf";
import "jspdf-autotable";

import logo from "../assets/img/logo.png";
import footerImg from "../assets/img/QR orden pago.png";
import { getToken } from "../utils/auth";
import { formatLegacyOrdenPagoDate, LEGACY_ORDENES_PAGO_PDF } from "./legacyOrdenPago";
import { renderOrdenPagoNuevo } from "./ordenPagoPdf";

const buildOrdenPagoFilename = (comercio, tipoTarjeta, fechaPago) => {
  const nombreLimpio = String(comercio || "orden_pago").replace(/[^a-z0-9]/gi, "_");
  const tipoNombre =
    tipoTarjeta === "QR"
      ? "_QR"
      : tipoTarjeta === "NARANJA S"
        ? "_NARANJA"
        : "_GENERAL";

  return `OrdenPago_${nombreLimpio}${tipoNombre}_${fechaPago}.pdf`;
};

const renderLegacyOrdenPagoPdf = (comercioData, tipoData, fechaPago) => {
  renderOrdenPagoNuevo({
    comercioData,
    tipoData,
    fechaPago,
    filename: buildOrdenPagoFilename(comercioData.comercio, tipoData.tipoTarjeta, fechaPago),
  });
  return;

  const doc = new jsPDF({ orientation: "portrait", unit: "pt", format: "a4" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const info = comercioData.info;
  const acumulados = tipoData.acumulados;
  const datos = tipoData.datos;
  const sumas = tipoData.sumas;

  const startX = 25;
  const startY = 25;
  const alto = 60;
  const usableWidth = pageWidth - startX * 2;
  const sectionWidth = usableWidth / 5;

  doc.setFillColor(255, 255, 255);
  doc.roundedRect(startX, startY, usableWidth, alto, 10, 10, "F");
  doc.setDrawColor(220);
  doc.setLineWidth(0.2);

  for (let i = 1; i < 5; i += 1) {
    const lineX = startX + i * sectionWidth;
    doc.setDrawColor(230);
    doc.line(lineX, startY + 8, lineX, startY + alto - 8);
  }

  const baseY = startY + 20;
  doc.addImage(logo, "PNG", startX + 25, baseY, 60, 28);

  const xOrden = startX + sectionWidth + sectionWidth / 2;
  const yOrden = startY + alto / 2;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(8);
  doc.text("ORDEN DE PAGO", xOrden, yOrden, { align: "center", baseline: "middle" });

  const xZoco = startX + sectionWidth * 2 + 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(5.5);
  doc.text("ZOCO - SERVICIOS DE PAGO", xZoco, baseY);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(5);
  doc.text("CUIT: 30 - 71.679.976 - 6", xZoco, baseY + 7);
  doc.text("liquidaciones@zocoweb.com.ar", xZoco, baseY + 14);
  doc.text("www.zocoweb.com.ar", xZoco, baseY + 21);

  const xCom = startX + sectionWidth * 3 + 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(5.5);
  doc.text("ESTABLECIMIENTO COMERCIAL", xCom, baseY);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(5);

  let line = baseY + 7;
  doc.text(`EMPRESA: ${info.empresa}`, xCom, line);
  line += 7;
  doc.text(`DIRECCIÓN: ${info.direccion}`, xCom, line);
  line += 7;
  doc.text(`PROVINCIA: ${info.provincia}`, xCom, line);
  line += 7;
  doc.text(`TEL: ${info.telefono ?? "-"}`, xCom, line);
  line += 7;
  doc.text(`EMAIL: ${info.email ?? "-"}`, xCom, line);

  const xFecha = startX + sectionWidth * 4 + 10;
  doc.setFont("helvetica", "bold");
  doc.setFontSize(5.5);
  doc.text("FECHA", xFecha, baseY);
  doc.setFont("helvetica", "normal");
  doc.setFontSize(5);

  let yFecha = baseY + 8;
  doc.text(`LIQUIDACIÓN: ${fechaPago}`, xFecha, yFecha);
  yFecha += 7;
  doc.text(`BANCO: ${info.banco ?? "-"}`, xFecha, yFecha);
  yFecha += 7;
  doc.text(`N° CUENTA: ${info.nroCuenta ?? "-"}`, xFecha, yFecha);

  const startYMontos = startY + alto + 30;
  doc.setFillColor(242, 244, 248);
  doc.roundedRect(45, startYMontos - 8, pageWidth - 90, 22, 10, 10, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("MONTO ACUMULADO (MES CORRIENTE)", pageWidth / 2, startYMontos + 8, {
    align: "center",
  });

  const labels = ["HOY SE ACREDITA", "ACUMULADO", "DÉBITO", "CUOTA"];
  const values = [
    acumulados.hoySeAcredita,
    acumulados.acumulado,
    acumulados.acumuladoDebito,
    acumulados.acumuladoCredito,
  ];
  const boxW = (pageWidth - 150) / 4;
  const baseX2 = 70;
  const baseYMontos = startYMontos + 28;

  labels.forEach((label, index) => {
    const x = baseX2 + index * boxW;
    doc.setDrawColor(210);
    doc.setFillColor(255, 255, 255);
    doc.roundedRect(x, baseYMontos, boxW - 30, 45, 14, 14, "F");
    doc.setFont("helvetica", "bold");
    doc.setFontSize(7);
    doc.text(label, x + (boxW - 30) / 2, baseYMontos + 12, {
      align: "center",
    });
    doc.setFontSize(9.5);
    doc.text(`$ ${values[index] || "0,00"}`, x + (boxW - 30) / 2, baseYMontos + 30, {
      align: "center",
    });
  });

  const columnas = [
    "Terminal",
    "N° Operación",
    "Fecha OP",
    "Tarjeta",
    "Cuotas",
    "Bruto",
    "Costo Fin.",
    "Anticipo",
    "Arancel",
    "IVA",
    "Cost. transc.",
    "Ret. IIBB",
    "Ret. Ganancia",
    "Ret. IVA",
    "Total OP",
  ];
  const filasTabla = datos.map((dato) => [
    dato.terminal,
    dato.nroOperacion,
    dato.fechaOperacion,
    dato.tarjeta,
    dato.cuotas,
    `$${dato.bruto}`,
    `$${dato.costoFinanciero}`,
    `$${dato.costoPorAnticipo}`,
    `$${dato.arancel}`,
    `$${dato.ivaArancel}`,
    `$${dato.impDebitoCredito}`,
    `$${dato.retencionIIBB}`,
    `$${dato.retencionGanancia}`,
    `$${dato.retencionIVA}`,
    `$${dato.totalOP}`,
  ]);

  doc.autoTable({
    startY: baseYMontos + 70,
    head: [columnas],
    body: filasTabla,
    styles: { fontSize: 6, halign: "center", cellPadding: 1.5 },
    headStyles: { fillColor: [0, 0, 0], textColor: [255, 255, 255] },
    alternateRowStyles: { fillColor: [245, 245, 245] },
    theme: "striped",
    margin: { left: 25, right: 25 },
    tableWidth: pageWidth - 50,
  });

  let finalY = doc.lastAutoTable.finalY;
  if (finalY > pageHeight - 260) {
    doc.addPage();
    finalY = 80;
  }

  const footerY = finalY + 20;
  const halfWidth = (pageWidth - 100) / 2;

  doc.setFillColor(255, 255, 255);
  doc.roundedRect(30, footerY - 20, pageWidth - 60, 200, 20, 20, "F");

  const leftX = 50;
  doc.setFillColor(242, 244, 248);
  doc.roundedRect(leftX, footerY - 5, halfWidth - 20, 20, 8, 8, "F");
  doc.setFont("helvetica", "bold");
  doc.setFontSize(9);
  doc.text("RESUMEN FISCAL", leftX + (halfWidth - 20) / 2, footerY + 8, {
    align: "center",
  });

  const resumenX = leftX + 10;
  const resumenY = footerY + 25;
  const resumenW = halfWidth * 0.55;

  doc.setFillColor(255, 255, 255);
  doc.roundedRect(resumenX, resumenY, resumenW, 140, 20, 20, "F");
  doc.setFontSize(8);
  doc.setFont("helvetica", "bold");
  doc.text("RESUMEN OPERACIONES", resumenX + 15, resumenY + 15);
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");

  const resumenData = [
    ["BRUTO", sumas.bruto],
    ["Arancel", sumas.arancel],
    ["IVA 21%", sumas.ivaArancel],
    ["Cost. transc.", sumas.impDebitoCredito],
    ["Costo Financiero", sumas.costoFinanciero],
    ["Costo Anticipo", sumas.costoPorAnticipo],
    ["RET. IIBB", sumas.retencionIIBB],
    ["RET. GANANCIAS", sumas.retencionGanancia],
    ["RET. IVA", sumas.retencionIVA],
  ];

  let yResumen = resumenY + 30;
  resumenData.forEach(([label, value]) => {
    doc.text(label, resumenX + 15, yResumen);
    doc.text(`$ ${value}`, resumenX + resumenW - 15, yResumen, {
      align: "right",
    });
    yResumen += 13;
  });

  doc.setFont("helvetica", "bold");
  doc.text("TOTAL OP", resumenX + 15, yResumen + 2);
  doc.text(`$ ${sumas.totalOP}`, resumenX + resumenW - 15, yResumen + 2, {
    align: "right",
  });

  const rightX = leftX + halfWidth + 10;
  const rightW = halfWidth - 20;
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(rightX, footerY - 5, rightW, 175, 20, 20, "F");
  doc.addImage(footerImg, "PNG", rightX + 10, footerY + 5, rightW - 20, 155);

  doc.save(buildOrdenPagoFilename(comercioData.comercio, tipoData.tipoTarjeta, fechaPago));
};

export const descargarOrdenPagoLegacy = async ({ documentoId, fechaPago, nombreComercio, cuit }) => {
  const token = getToken();
  const fechaLiqStr = formatLegacyOrdenPagoDate(fechaPago);
  const isDarkMode = document.body.classList.contains("dark-mode");

  const result = await Swal.fire({
    title: "¿Qué deseas hacer?",
    text: "Selecciona una opción para la descarga del documento.",
    imageUrl: logo,
    imageWidth: 100,
    imageHeight: 30,
    imageAlt: "Logo",
    showCancelButton: true,
    confirmButtonText: "Descargar uno",
    cancelButtonText: "Descargar todos",
    buttonsStyling: false,
    customClass: {
      container: isDarkMode
        ? "swal2-container--dark swal-session-warning"
        : "swal2-container--light swal-session-warning",
      confirmButton: "my-swal-button",
      cancelButton: "my-swal-button2",
    },
  });

  const response = await fetch(LEGACY_ORDENES_PAGO_PDF, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      Token: token,
      Id: String(documentoId),
      FechaPago: fechaLiqStr,
      comercio: result.isConfirmed ? nombreComercio : "todos",
      cuit,
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(errorText || "No se pudo descargar");
  }

  const data = await response.json();
  for (const comercioData of data.comercios || []) {
    for (const tipoData of comercioData.tiposTarjeta || []) {
      renderLegacyOrdenPagoPdf(comercioData, tipoData, fechaLiqStr);
    }
  }
};

export const descargarOrdenPagoDesdePayload = async ({ fechaPago, payload }) => {
  const fechaLiqStr = formatLegacyOrdenPagoDate(fechaPago);
  const isDarkMode = document.body.classList.contains("dark-mode");

  await Swal.fire({
    title: "Orden de pago",
    text: "Se generará el PDF con los datos conciliados del CRM Postventa.",
    imageUrl: logo,
    imageWidth: 100,
    imageHeight: 30,
    imageAlt: "Logo",
    confirmButtonText: "Continuar",
    buttonsStyling: false,
    customClass: {
      container: isDarkMode
        ? "swal2-container--dark swal-session-warning"
        : "swal2-container--light swal-session-warning",
      confirmButton: "my-swal-button",
    },
  });

  for (const comercioData of payload?.comercios || []) {
    for (const tipoData of comercioData?.tiposTarjeta || []) {
      renderLegacyOrdenPagoPdf(comercioData, tipoData, fechaLiqStr);
    }
  }
};
